import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeVariant = api(async function removeVariant({ scenarioId, variantId }) {
    return mutate(
        gql`
            mutation RemoveVariant($scenarioId: String!, $variantId: String!) {
                removeVariant(scenarioId: $scenarioId, variantId: $variantId)
            }
        `,
        { scenarioId, variantId },
        { returns: "removeVariant" }
    )
})
